import { __assign } from "tslib";
import * as React from 'react';
import { Money } from '@websky/core/src';
import { useFormState } from 'react-final-form';
import cn from 'classnames';
import css from '../PassengersCheckPopup.css';
var PriceWithSubsidy = function (_a) {
    var totalPrice = _a.totalPrice, subsidyInfo = _a.subsidyInfo;
    var formData = useFormState();
    var priceWithSubsidy = React.useMemo(function () {
        var subsidyAmount = 0;
        subsidyInfo.segments.forEach(function (segment, segmentId) {
            var _a, _b;
            if ((_b = (_a = formData.values) === null || _a === void 0 ? void 0 : _a['segments']) === null || _b === void 0 ? void 0 : _b.hasOwnProperty(segmentId)) {
                segment.travellers.forEach(function (traveller, travellerIndex) {
                    var _a, _b, _c, _d, _e;
                    if ((_c = (_b = (_a = formData.values['segments'][segmentId]) === null || _a === void 0 ? void 0 : _a['travellers']) === null || _b === void 0 ? void 0 : _b[travellerIndex]) === null || _c === void 0 ? void 0 : _c['check']) {
                        subsidyAmount += ((_e = (_d = traveller.subsidyInfo) === null || _d === void 0 ? void 0 : _d.discount) === null || _e === void 0 ? void 0 : _e.amount) || 0;
                    }
                });
            }
        });
        return __assign(__assign({}, totalPrice), { amount: totalPrice.amount - subsidyAmount });
    }, [formData.values, totalPrice, subsidyInfo]);
    return React.createElement(Money, { money: priceWithSubsidy, moneyClassName: cn(css.money, css.money_new) });
};
export default PriceWithSubsidy;
